// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".judge-status[data-v-59d68fc0],.point[data-v-59d68fc0]{font-weight:700;font-size:20px}.options[data-v-59d68fc0]{width:50%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
